import { Link } from "react-router-dom";

export function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-ivory/80 mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 py-16 grid gap-12 md:grid-cols-2 lg:grid-cols-4">
        <div className="lg:col-span-2 max-w-md">
          <div className="flex items-center gap-3">
            <img src="/lion-logo.webp" alt="Lord Almighty crest" className="h-11 w-11 object-contain" />
            <span className="font-display text-2xl text-ivory font-semibold">Lord Almighty</span>
          </div>
          <p className="mt-5 text-sm leading-relaxed text-ivory/70">
            Strengthening the body of Christ and advancing God's Kingdom — supporting churches,
            ministries, artists, and Christ-centered businesses so faith can flourish and more
            lives can be reached with the love of Jesus.
          </p>
          <p className="mt-4 text-xs text-ivory/50">
            We are the founders of Jesus United. We have supported The Chosen series. Mention of
            The Chosen does not imply an official partnership or endorsement.
          </p>
        </div>

        <div>
          <h4 className="font-display text-lg text-gold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {[
              ["/mission", "Our Mission"],
              ["/churches", "Churches & Properties"],
              ["/support", "Ministry & Artist Support"],
              ["/directory", "Kingdom Business Directory"],
              ["/jesus-united", "Jesus United"],
            ].map(([to, label]) => (
              <li key={to}>
                <Link to={to} className="text-ivory/70 hover:text-gold transition-colors">{label}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-display text-lg text-gold mb-4">Connect</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/connect" className="text-ivory/70 hover:text-gold transition-colors">Connect & Partner</Link></li>
            <li><Link to="/fund" className="text-ivory/70 hover:text-gold transition-colors">Fuel the Ministry</Link></li>
            <li><a href="https://www.jesusunited.org" target="_blank" rel="noopener noreferrer" className="text-ivory/70 hover:text-gold transition-colors">JesusUnited.org</a></li>
            <li><Link to="/privacy" className="text-ivory/70 hover:text-gold transition-colors">Privacy Policy</Link></li>
            <li><Link to="/terms" className="text-ivory/70 hover:text-gold transition-colors">Terms of Use</Link></li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="mx-auto max-w-7xl px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ivory/50">
          <p>© {year} Lord Almighty. All rights reserved.</p>
          <p>Intended domain: LordAlmighty.com</p>
        </div>
      </div>
    </footer>
  );
}
